/**
 * IST (India Standard Time, UTC+5:30) time helpers.
 * Server may be in UTC and clients may be in any timezone — we always render IST.
 */
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

function pad(n) { return String(n).padStart(2, "0"); }

/**
 * Returns IST-adjusted parts of the given (or current) Date, using UTC accessors
 * on a time-shifted copy so browser TZ is irrelevant.
 */
export function istParts(date) {
  const d = new Date((date || new Date()).getTime() + IST_OFFSET_MS);
  return {
    h: d.getUTCHours(),
    m: d.getUTCMinutes(),
    s: d.getUTCSeconds(),
    D: d.getUTCDate(),
    M: d.getUTCMonth() + 1,
    Y: d.getUTCFullYear(),
    weekday: d.getUTCDay(),
    epochMs: date ? date.getTime() : Date.now(),
  };
}

export function istTimeStr(date) {
  const p = istParts(date);
  return `${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`;
}

export function istDateStr(date) {
  const p = istParts(date);
  return `${pad(p.D)}-${pad(p.M)}-${p.Y}`;
}

export function istISODateStr(date) {
  const p = istParts(date);
  return `${p.Y}-${pad(p.M)}-${pad(p.D)}`;
}

/** For filenames / snapshot names */
export function istStampFilename(date) {
  const p = istParts(date);
  return `${p.Y}-${pad(p.M)}-${pad(p.D)}_${pad(p.h)}-${pad(p.m)}-${pad(p.s)}_IST`;
}

/** For headers / login pages */
export function istFullStr(date) {
  return `${istDateStr(date)} ${istTimeStr(date)} IST`;
}

/** Fraction (0..1) of current IST day for the 24hr timeline scrubber */
export function istDayFraction(date) {
  const p = istParts(date);
  return (p.h * 3600 + p.m * 60 + p.s) / 86400;
}
